import { useCallback } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { type AbsoluteRoute, type RouteParams } from "../../../core/routes";
import { RouteEntities } from "../../../core/routes/relativeRoutes";
import { LensGranularity, type LensInsightsTab } from "../../models";
import { INSIGHTS_TIME_RANGE_PARAM, buildInsightsTabPath, isLensInsightsTab } from "../../utils/insightsNavigation";

interface InsightsSelectedTabResult {
    resolvedTab: LensInsightsTab | undefined;
    navigateToTab: (tab: LensInsightsTab) => void;
}

export const useInsightsSelectedTab = (): InsightsSelectedTabResult => {
    const { insightsTab, orgId, lensFolderId } = useParams<RouteParams[AbsoluteRoute.ORG_LENS_FOLDER_INSIGHTS_TAB]>();
    const navigate = useNavigate();
    const location = useLocation();

    const resolvedTab: LensInsightsTab | undefined = isLensInsightsTab(insightsTab) ? insightsTab : undefined;

    const navigateToTab = useCallback(
        (tab: LensInsightsTab) => {
            const pathname = buildInsightsTabPath({ orgId, lensFolderId, insightsTab: tab });
            const params = new URLSearchParams(location.search);
            const tr = params.get(INSIGHTS_TIME_RANGE_PARAM);
            if (
                tab !== RouteEntities.Monetization &&
                (tr === LensGranularity.ThreeMonths || tr === LensGranularity.TwoMonths)
            ) {
                params.set(INSIGHTS_TIME_RANGE_PARAM, LensGranularity.Month);
            }
            navigate({ pathname, search: params.toString() });
        },
        [orgId, lensFolderId, navigate, location.search],
    );

    return { resolvedTab, navigateToTab };
};
